import React from 'react';
import { X, Tv, ExternalLink } from 'lucide-react';

interface LegalModalProps {
  page: string;
  onClose: () => void;
}

export default function LegalModal({ page, onClose }: LegalModalProps) {
  // Lista dos canais parceiros extraída das suas imagens
  const partnersList = [
    { name: "Film Plus", desc: "2,76 mi de inscritos", url: "https://www.youtube.com/@filmplusbr" },
    { name: "Film Plus Family", desc: "514 mil inscritos", url: "https://www.youtube.com/@filmplusfamily" },
    { name: "Film Plus Emotion", desc: "558 mil inscritos", url: "https://www.youtube.com/@filmplusemotion" },
    { name: "Cinemateca", desc: "197 mil inscritos", url: "https://www.youtube.com/@CinematecaFilmes" },
    { name: "Cinema em Casa", desc: "250 mil inscritos", url: "https://www.youtube.com/@cinemaemcasagratis" },
    { name: "Film Plus USA", desc: "101 mil inscritos", url: "https://www.youtube.com/@filmplususa" },
    { name: "Cine Mania", desc: "383 mil inscritos", url: "https://www.youtube.com/@CineManiaWes" },
    
    
    
    { name: "MoviePlay - Filmes em Português", desc: "383 mil inscritos", url: "https://www.youtube.com/@MoviePlayFilmes" },
    { name: "Star Filmes", desc: "111 mil inscritos", url: "https://www.youtube.com/@StarFilmesGratis" },
    
    { name: "Pluto TV Brasil", desc: "Streaming Parceiro", url: "https://www.youtube.com/@PlutoTVBrasil" },
    
    { name: "Swen Filmes", desc: "Destaque Parceiro", url: "https://www.youtube.com/@SwenFilmes" },
   
    { name: "Chicha Drama", desc: "Doramas & Séries", url: "https://www.youtube.com/@ChichaDrama" },
    { name: "BALEEIRO GAMES", desc: "Gameplay & Crias", url: "https://www.youtube.com/@BALEEIROGAMES" },
    
  ];

  const renderContent = () => {
    switch (page) {
      case 'termos':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Termos de Uso & Política de Privacidade</h2>
            <p style={{ fontSize: '12px', color: '#888', marginBottom: '20px' }}>Última atualização: Setembro de 2026</p>
            
            <h3 style={{ color: '#E50914', marginTop: '20px' }}>1. Nossa Missão</h3>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              O Doisplay é o seu espaço para curtir grandes momentos. Nosso objetivo é ser a sua vitrine favorita para descobrir filmes, trailers e novidades de um jeito leve e sem complicação. Queremos que você se sinta em casa, em um ambiente seguro, feito para compartilhar diversão com quem você gosta. E o melhor: nossa equipe está trabalhando todos os dias nos bastidores criando <strong>novas funções</strong> para deixar sua experiência cada vez mais completa!
            </p>

            <h3 style={{ color: '#E50914', marginTop: '20px' }}>2. Convivência e Regras de Conduta</h3>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Para que a nossa casa continue sendo um ambiente incrível e saudável para todas as idades, nós somos extremamente firmes com as nossas regras. Não toleramos absolutamente nenhum tipo de discriminação, discursos de ódio, ofensas, fraudes ou promoção de atividades ilícitas (como jogos de azar). Se um usuário desrespeitar essas diretrizes e for denunciado, ele será notificado oficialmente. Dependendo da gravidade e da análise da nossa equipe, a conta poderá ser suspensa por 30 dias para reflexão ou <strong>deletada permanentemente</strong> da plataforma.
            </p>

            <h3 style={{ color: '#E50914', marginTop: '20px' }}>3. Sobre os Conteúdos</h3>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Nós organizamos a dedo os melhores conteúdos do YouTube para facilitar sua vida. Esses vídeos pertencem aos seus respectivos criadores, e qualquer anúncio exibido nos players é de direito e benefício exclusivo deles. Respeitamos o trabalho de cada artista e funcionamos apenas como a ponte entre você e a diversão.
            </p>

            <h3 style={{ color: '#E50914', marginTop: '20px' }}>5. Proteção aos Menores</h3>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              O Doisplay é um ambiente familiar, mas a internet é imensa e a supervisão dos pais é indispensável. Sempre que um conteúdo for para o público infantil, tentaremos sinalizar, mas recomendamos fortemente que os pais ou responsáveis acompanhem de perto o que os menores estão assistindo para garantir que a diversão seja sempre 100% segura.
            </p>
          </div>
        );

      case 'quem-somos':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Quem Somos</h2>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              O <strong>Doisplay</strong> nasceu de uma paixão genuína por conectar pessoas através do entretenimento. Nossa missão é clara: levar diversão de maneira leve e com responsabilidade, utilizando as melhores tecnologias disponíveis no mercado. Somos feitos por pessoas reais, para pessoas reais.
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              Não queremos ser só mais uma plataforma. Queremos ser o seu refúgio de lazer. É por isso que não ficamos parados; nossa equipe técnica está neste exato momento programando e estruturando <strong>novas funções exclusivas</strong> que chegarão em breve para melhorar ainda mais o seu uso.
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Nossos pilares fundamentais são a segurança, a transparência, o respeito rigoroso aos direitos autorais e o foco total em entregar uma experiência rápida e fluida para você e sua família.
            </p>
          </div>
        );

        case 'como-funciona':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Como Funciona o Doisplay?</h2>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              O <strong>Doisplay</strong> funciona como um <strong>indexador e vitrine inteligente</strong> de trailers, filmes e vídeos selecionados da internet. Nós não hospedamos arquivos de vídeo em servidores próprios; utilizamos os players oficiais integrados (como do YouTube e parceiros licenciados) para organizar o conteúdo de forma limpa, rápida e segura para você.
            </p>

            <h3 style={{ color: '#E50914', marginTop: '20px' }}>Valorização Total dos Criadores</h3>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              Nós amamos e respeitamos o ecossistema dos criadores de conteúdo e detentores de direitos. Por isso, quando você assiste a um vídeo ou trailer em nossa plataforma:
            </p>
            <ul style={{ lineHeight: '1.6', color: '#ccc', paddingLeft: '20px', marginBottom: '15px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <li><strong>Views Reais:</strong> A visualização, o engajamento e os anúncios contam 100% diretamente para o canal oficial do criador ou detentor no YouTube. Nós ajudamos a dar visibilidade e tráfego orgânico para eles!</li>
              <li><strong>Canais Parceiros:</strong> Produtoras e canais licenciados possuem destaque especial em nossa vitrine. Você pode acessar a lista completa de parceiros direto pelo rodapé e visitar as páginas oficiais deles a um clique.</li>
            </ul>

            <h3 style={{ color: '#E50914', marginTop: '20px' }}>Transparência e Licenciamento</h3>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Somos uma ponte limpa e transparente entre o público e as produtoras licenciadas de filmes e entretenimento. Garantimos diversão de qualidade com total respeito às diretrizes de direitos autorais.
            </p>
          </div>
        );

      case 'denuncie':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Central de Denúncias</h2>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              A saúde do Doisplay depende da nossa comunidade. Nós levamos a segurança muito a sério. Se você se deparar com qualquer conteúdo, perfil ou atitude que quebre nossas regras (como ofensas, fraudes, atividades ilegais ou desrespeito), não se cale. Nós queremos saber imediatamente.
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              Envie um e-mail com os detalhes do ocorrido para a nossa equipe de moderação no endereço abaixo:
            </p>
            <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#E50914', marginBottom: '15px' }}>
              suportedoisplay@gmail.com
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Cada caso é tratado de forma totalmente confidencial e analisado com rigor. Faremos a triagem e tomaremos as atitudes cabíveis (como a suspensão ou exclusão da conta infratora) dando um retorno para você em <strong>até 48 horas</strong>.
            </p>
          </div>
        );

      case 'suporte':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Suporte & Ajuda</h2>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              Teve algum problema, ficou com alguma dúvida sobre a plataforma ou teve uma ideia brilhante para o aplicativo? Nós adoramos conversar!
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              Como estamos sempre evoluindo e criando <strong>novas funcionalidades</strong>, o feedback dos nossos usuários é o nosso maior guia. Fale diretamente com a gente enviando uma mensagem para:
            </p>
            <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#E50914', marginBottom: '15px' }}>
              suportedoisplay@gmail.com
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Nossa equipe de atendimento é humana e dedicada (nada de robôs com respostas prontas!). Vamos ler o seu e-mail com todo o cuidado e responderemos em <strong>até 48 horas</strong>.
            </p>
          </div>
        );

      case 'cookies':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Política de Cookies</h2>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              Nós valorizamos e respeitamos a sua privacidade. Utilizamos apenas os "cookies" técnicos e essenciais nos bastidores para lembrar de preferências básicas — como a sua configuração de volume ou o modo como a tela deve se comportar no seu celular ou PC.
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Nada de rastreamentos chatos ou invasivos. O único objetivo dessas informações é fazer com que a plataforma carregue mais rápido e torne o seu momento de lazer o mais suave possível a cada visita.
            </p>
          </div>
        );

      case 'parceiro':
        return (
          <div>
            <h2 style={{ color: '#fff', marginBottom: '15px' }}>Nossa Fonte e Parceria (TMDB)</h2>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              O <strong>Doisplay</strong> utiliza a robusta base de dados do <a href="https://www.themoviedb.org" target="_blank" rel="noopener noreferrer" style={{ color: '#3b82f6', textDecoration: 'underline' }}>TMDB (The Movie Database)</a> como nossa principal fonte de referência. 
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc', marginBottom: '15px' }}>
              É graças a essa parceria e integração tecnológica que conseguimos trazer para você informações detalhadas, sinopses completas, fichas de elenco atualizadas, além de uma imensidão de <strong>trailers e lançamentos</strong> de filmes e séries em primeira mão.
            </p>
            <p style={{ lineHeight: '1.6', color: '#ccc' }}>
              Todo o catálogo de metadados é organizado para proporcionar a navegação mais limpa, rápida e prazerosa possível diretamente na nossa plataforma.
            </p>
          </div>
        );

      case 'canais-parceiros':
        return (
          <div>
            <h3 style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '18px', color: '#fff' }}>
              <Tv color="#3b82f6" size={22} /> Família Film Plus & Canais Parceiros
            </h3>
            <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '20px' }}>
              Conheça os canais e produtoras parceiras que trazem grandes sucessos para o nosso ecossistema.
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px' }}>
              {partnersList.map((partner, index) => (
                <div key={index} style={{
                  backgroundColor: '#1f1f1f', padding: '12px 15px', borderRadius: '8px',
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #2a2a2a'
                }}>
                  <div>
                    <h5 style={{ margin: 0, fontSize: '13px', color: '#fff', fontWeight: 'bold' }}>{partner.name}</h5>
                    <span style={{ fontSize: '11px', color: '#888' }}>{partner.desc}</span>
                  </div>
                  <a 
                    href={partner.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ backgroundColor: '#2563eb', color: '#fff', padding: '6px 10px', borderRadius: '4px', fontSize: '11px', textDecoration: 'none', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}
                  >
                    Ver <ExternalLink size={10} />
                  </a>
                </div>
              ))}
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#141414', padding: '40px', borderRadius: '8px', width: '100%', maxWidth: '700px',
        maxHeight: '85vh', overflowY: 'auto', color: '#fff', position: 'relative', border: '1px solid #333'
      }}>
        <button 
          onClick={onClose}
          style={{ position: 'absolute', top: '20px', right: '20px', background: 'none', border: 'none', color: '#aaa', cursor: 'pointer' }}
        >
          <X size={24} />
        </button>

        {renderContent()}
      </div>
    </div>
  );
}